export default {
	sec_01: {
		title: {
			one: 'Getting Started',
			two: 'JP WORLD ',
			three: 'Pay',
		},
		desc: {
			one: 'Everything starts with a business account.',
			two: 'Join over 30 million sellers who rely on JP WORLD Pay',
		},
		btn: {
			one: 'Sign up',
			two: 'Contact Sales Department',
		},
	},
	sec_14: {
		btn: 'Contact your account specialist to get started.',
	},
	sec_04: {
		title: {
			one: 'Easy Settings',
		},
		desc: {
			one: "Inquiry. We'll help you.",
		},
		cards: {
			one: {
				title: {
					one: 'Registration is free',
				},
				description: {
					one: 'You only need an email address and',
					two: 'some basic information about your business.',
				},
				btn: 'Join a business account',
			},
			two: {
				title: {
					one: 'Start Payment',
				},
				description: {
					one: 'Once you confirm your email address and ',
					two: 'company name and link your JP WORLD Pay',
					three: 'account, you complete your first sales ',
					four: 'preparation.',
				},
			},
		},
		btn: 'JP WORLD Pay',
	},
};
